import React from "react";
import { Box, Divider } from "@mui/material";
import AppButton from "../../../../../../views/components/common/buttons/AppButton";
import ImageUpload from "../../../../../../views/components/common/upload/ImageUpload";

type Props = {
  productId?: number | string;
  editMockupId?: number | null;
  editMode: boolean;
  embedded: boolean;
  isCompactUploadDialog: boolean;
  isBusy: boolean;
  generatingMockup: boolean;
  updatingMockupId?: number | null;
  manualUploadFiles: File[];
  onFilesChange: (files: File[]) => void;
  onRemovePreview: (image: { title?: string }) => void;
  skuSelected?: boolean;
  onSave: () => void;
  onClose: () => void;
};

const MockupManualUploadTab: React.FC<Props> = ({
  productId,
  editMockupId,
  editMode,
  embedded,
  isCompactUploadDialog,
  isBusy,
  generatingMockup,
  updatingMockupId,
  manualUploadFiles,
  onFilesChange,
  onRemovePreview,
  skuSelected = true,
  onSave,
  onClose,
}) => (
  <Box
    sx={{
      mt: isCompactUploadDialog ? 1 : 2,
      display: "flex",
      flexDirection: "column",
      ...(embedded && { flex: 1, minHeight: 0, height: "100%" }),
    }}
  >
    {!isCompactUploadDialog && <Divider sx={{ mb: 2 }} />}
    <Box
      sx={
        embedded
          ? {
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }
          : undefined
      }
    >
      <ImageUpload
        id={`modal-manual-upload-${String(productId || "")}-${String(editMockupId || "new")}`}
        size={isCompactUploadDialog ? "medium" : "large"}
        previewImage
        showImagesList={!editMode}
        multiple={!editMode}
        existingImageList={[]}
        newImageList={manualUploadFiles}
        minHeight={embedded ? "100%" : isCompactUploadDialog ? "280px" : "420px"}
        minInputWidth="100%"
        minWidth="100%"
        uploadText={isCompactUploadDialog ? "Drop mockup images here" : undefined}
        disabled={generatingMockup || (editMode && updatingMockupId === editMockupId)}
        addImagesToBeUploaded={(files) => onFilesChange(files ?? [])}
        deleteImage={onRemovePreview}
        removeImage={onRemovePreview}
      />
    </Box>
    <Box
      sx={{
        mt: isCompactUploadDialog ? 2.5 : "auto",
        pt: 2,
        pb: isCompactUploadDialog ? 0.5 : 0,
        display: "flex",
        justifyContent: "flex-end",
        gap: 1,
      }}
    >
      {isCompactUploadDialog && !embedded && (
        <AppButton
          label="Cancel"
          variant="grayscale"
          onClick={onClose}
          disabled={isBusy}
          customStyles={{ width: "120px" }}
        />
      )}
      <AppButton
        label={
          editMode && updatingMockupId === editMockupId
            ? "Saving..."
            : generatingMockup
              ? "Uploading..."
              : isCompactUploadDialog
                ? editMode
                  ? "Replace mockup"
                  : "Upload mockups"
                : "Save upload"
        }
        variant="primary"
        onClick={onSave}
        disabled={
          !skuSelected ||
          !manualUploadFiles?.length ||
          generatingMockup ||
          (editMode && updatingMockupId === editMockupId)
        }
        customStyles={{ width: isCompactUploadDialog ? "160px" : "150px" }}
      />
    </Box>
  </Box>
);

export default MockupManualUploadTab;
